import React from 'react';
import './style.css';

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentYear: new Date().getFullYear()
        };
    }

    render() {
        const { currentYear } = this.state;

        return (
            <footer className="app-footer">
                {/* Main Footer */}
                <div className="footer-main">
                    <div className="footer-container">
                        <div className="footer-content">
                            {/* Brand Section */}
                            <div className="footer-brand">
                                <a href="/" className="footer-logo">
                                    <img src="/images/logo_sas.png" alt="Times Schools" />
                                    <div className="footer-logo-text">
                                        <h3 className="footer-logo-title">SAS CMS</h3>
                                        <p className="footer-logo-subtitle">School Management System</p>
                                    </div>
                                </a>
                                <p className="footer-description">
                                    Hệ thống quản lý trường học toàn diện, giúp số hóa và tối ưu hóa
                                    các quy trình vận hành của nhà trường.
                                </p>
                            </div>

                            {/* Contact Section */}
                            <div className="footer-contact">
                                <h4 className="footer-section-title">Liên hệ</h4>
                                <ul className="footer-contact-list">
                                    <li className="footer-contact-item">
                                        <div className="footer-contact-icon">
                                            <i className="fas fa-map-marker-alt"></i>
                                        </div>
                                        <div className="footer-contact-text">
                                            Số 1 Bách Khoa, Hai Bà Trưng, Hà Nội
                                        </div>
                                    </li>
                                    <li className="footer-contact-item">
                                        <div className="footer-contact-icon">
                                            <i className="fas fa-envelope"></i>
                                        </div>
                                        <div className="footer-contact-text">
                                            <a href="mailto:lienhe@timesschools.io.vn">
                                                lienhe@timesschools.io.vn
                                            </a>
                                        </div>
                                    </li>
                                    <li className="footer-contact-item">
                                        <div className="footer-contact-icon">
                                            <i className="fas fa-phone-alt"></i>
                                        </div>
                                        <div className="footer-contact-text">
                                            <a href="tel:0988000123">0988 000 123</a>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            {/* Social Section */}
                            <div className="footer-social">
                                <h4 className="footer-section-title">Kết nối</h4>
                                <div className="footer-social-list">
                                    <a
                                        href="https://facebook.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="footer-social-link"
                                        title="Facebook"
                                    >
                                        <i className="fab fa-facebook-f"></i>
                                    </a>
                                    <a
                                        href="https://youtube.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="footer-social-link"
                                        title="YouTube"
                                    >
                                        <i className="fab fa-youtube"></i>
                                    </a>
                                    <a
                                        href="https://zalo.me"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="footer-social-link"
                                        title="Zalo"
                                    >
                                        <i className="fas fa-comment-dots"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="footer-bottom">
                    <div className="footer-container">
                        <div className="footer-bottom-content">
                            <p className="footer-copyright">
                                © {currentYear} Times Schools. All rights reserved.
                            </p>
                            <div className="footer-version">
                                <span className="footer-version-badge">v1.0.0</span>
                                <span className="footer-version-text">Stable Release</span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;
